module.exports = __webpack_public_path__ + "assets/img/fb.d5b03bed.png";